module.exports = __webpack_public_path__ + "static/true-grit-5924c85ff1d99d060b1de30f20af24b0.jpg";